import http from "@/api/request";
import { MEMBER_OPS_BASE } from "@/config/apiBaseUrlConfig";

import type {
  OpsMemberDetailQueryRequest,
  OpsMemberDetailVO,
  OpsMemberPageQueryRequest,
  OpsMemberRemarkUpdateRequest,
  OpsMemberTagsUpdateRequest,
  PageDataOpsMemberPageVO,
} from "./type";

/**
 * 会员分页列表
 * GET /service-chijing-member/api/ops/member/getPage
 * orgId+orgType 与 shopId 互斥；STORE 直查，非 STORE Feign 解析门店
 * @param params 分页与筛选条件
 */
export const getMemberPage = (params?: OpsMemberPageQueryRequest) => {
  return http.get<PageDataOpsMemberPageVO>(`${MEMBER_OPS_BASE}/getPage`, { params });
};

/**
 * 会员详情
 * GET /service-chijing-member/api/ops/member/getMember/{id}
 * 一次返回头图及账户/档案/统计三个 Tab；Query 用于账户流水分页筛选
 * @param id 会员 ID
 * @param params 账户明细筛选与分页
 */
export const getMemberDetail = (id: string, params?: OpsMemberDetailQueryRequest) => {
  return http.get<OpsMemberDetailVO>(`${MEMBER_OPS_BASE}/getMember/${id}`, { params });
};

/**
 * 更新会员备注
 * PUT /service-chijing-member/api/ops/member/updateRemark/{id}
 * @param id 会员 ID
 * @param data 备注内容，空串表示清空
 */
export const updateMemberRemark = (id: string, data: OpsMemberRemarkUpdateRequest) => {
  return http.put(`${MEMBER_OPS_BASE}/updateRemark/${id}`, data);
};

/**
 * 更新会员标签
 * PUT /service-chijing-member/api/ops/member/updateTags/{id}
 * clearAll 优先；否则 addTags 追加、removeTags 删除
 * @param id 会员 ID
 * @param data 标签更新参数
 */
export const updateMemberTags = (id: string, data: OpsMemberTagsUpdateRequest) => {
  return http.put(`${MEMBER_OPS_BASE}/updateTags/${id}`, data);
};
